export default "__VITE_ASSET__Byi$bQHc__"